import { render } from "./BriefcaseOutline.vue?vue&type=template&id=138102c4"
import script from "./BriefcaseOutline.vue?vue&type=script&lang=js"
export * from "./BriefcaseOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__